import NotFound from '@/pages/NotFound';
import Box from '@mui/material/Box';
import { Helmet } from 'react-helmet';
import CallingTab from './CallingTab';
import DashboardTab from './DashboardTab';
import DetailTab from './DetailTab';
import ListDetailRightPanel from './ListDetailRightPanel';
import PageHead from './PageHead';
import { UnsavedRocketChangesGuardProvider } from './UnsavedRocketChangesGuard';
import { useListDetailPage } from './useListDetailPage';

export default function ListDetailPage() {
  const page = useListDetailPage();

  if (page.showNotFound) {
    return <NotFound />;
  }

  return (
    <UnsavedRocketChangesGuardProvider>
      <Helmet>
        <meta charSet="utf-8" />
        <title>List Manager - List Details</title>
        <meta name="description" content="List Manager - List Details" />
      </Helmet>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          height: "inherit",
          justifyContent: "center",
          width: '100%',
          minWidth: 0
        }}>
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            maxWidth: "2000px",
            padding: "2rem",
            minWidth: 0,
            width: '100%',
            boxSizing: 'border-box'
          }}>
          <PageHead
            isLoading={page.isLoading}
            handleTopValueChange={page.handleTopValueChange}
            disableTabs={page.rightPanelOpen}
            topTabValue={page.selectTabValue}
            allContacts={page.allContacts}
            disableToggle={page.disableToggle}
            handleAllContactsChange={page.handleAllContactsChange}
            list={page.listMetadata}
            callStatistics={page.listStatistics}
            isUserACoordinator={page.isUserACoordinator}
            isUserACaller={page.isUserACaller}
            setViewContactedChecked={page.setViewContactedChecked}
            viewContactedChecked={page.viewContactedChecked}
          />
          {page.selectTabValue === 'dashboard' && (
            <DashboardTab
              list={page.listMetadata}
              rightPanelOpen={page.rightPanelOpen}
              handleOpenRightPanel={page.handleOpenRightPanel}
              isLoading={page.isLoading}
            />
          )}
          {page.selectTabValue === 'detail' && (
            <DetailTab
              isLoading={page.isLoading || page.isLoadingListMembers}
              disableToggle={page.disableToggle}
              pageNo={page.pageNo}
              setPageNo={page.setPageNo}
              setFilterOptions={page.setFilterOptions}
              pageSize={page.pageSize}
              setPageSize={page.setPageSize}
              setCallingViewContactIndex={page.setCallingViewContactIndex}
              changeTab={page.changeTab}
              onSortModelChange={page.onSortModelChange}
              sortModel={page.sortModel}
              rightPanelOpen={page.rightPanelOpen}
              handleOpenRightPanel={page.handleOpenRightPanel}
              listObjIsACoordinator={page.isUserACoordinator}
              userIsCaller={page.isUserACaller}
              list={page.listMembers}
              setEnterCallingByTableClick={page.setEnterCallingByTableClick}
              selectedContacts={page.selectedContacts}
              setSelectedContacts={page.setSelectedContacts}
            />
          )}

          {page.selectTabValue === 'calling' && (
            <CallingTab
              queryParameters={page.detailedQueryParams}
              callingViewContactIndex={page.callingViewContactIndex}
              setCallingViewContactIndex={page.setCallingViewContactIndex}
              list={page.listMembers}
              pageNo={page.pageNo}
              enterCallingByTableClick={page.enterCallingByTableClick}
              setEnterCallingByTableClick={page.setEnterCallingByTableClick}
              viewContactedChecked={page.viewContactedChecked}
              listsAreLoadingAndOrFetching={page.listsAreLoadingAndOrFetching}
            />
          )}
        </Box>
        <ListDetailRightPanel
          listId={page.listId}
          listMetadata={page.listMetadata}
          rightPanelOpen={page.rightPanelOpen}
          rightPanelContent={page.rightPanelContent}
          setRightPanelOpen={page.setRightPanelOpen}
          handleAssign={page.handleAssign}
          handleOtherActionsClose={page.handleOtherActionsClose}
          selectedContacts={page.selectedContacts}
          sortModel={page.sortModel}
        />
      </Box>
    </UnsavedRocketChangesGuardProvider>
  );
}
